import { getApiUrl } from './apiConfig';

/**
 * Turn stored avatar/media paths into a browser-loadable URL.
 * - Absolute http(s) URLs are returned unchanged (OAuth avatars, CDNs).
 * - Root-relative paths (/uploads/...) are resolved against the API origin
 *   so they work when the React app runs on a different port than the API.
 * Uses getApiUrl() at call time (not module init) so hostname/env stay correct.
 */
export function resolveMediaUrl(url) {
  if (url == null || url === '') return undefined;
  if (typeof url !== 'string') return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  // Optimistic local previews while background upload runs
  if (/^blob:/i.test(trimmed)) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) {
    // Drop stale localhost URLs that point to a dev server port that no longer
    // exists (e.g. http://localhost:7070/... or http://localhost:37857/...).
    // Our own API always runs on localhost:3001 (dev) or a non-localhost host
    // (production).  Any other localhost URL is stale test/dev data.
    const staleLocalhost = /^https?:\/\/localhost:(?!3001\b)\d+/i.test(trimmed);
    if (staleLocalhost) return undefined;
    return trimmed;
  }
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (trimmed.startsWith('/')) {
    const base = String(getApiUrl() || '').replace(/\/$/, '');
    return base ? `${base}${trimmed}` : trimmed;
  }
  return trimmed;
}
